// src/components/CheckableGroup/context.ts
import { createContext } from "react";
var CheckableGroupContext = createContext({
  name: "",
  variant: "primary",
  totalItems: 0,
  maxItems: Infinity,
  isExpanded: false,
  setIsExpanded: () => {},
  setTotalItems: () => {}
});
export { CheckableGroupContext };